import { FC, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import { handleLocaleUrl } from 'dibs-intl/exports/urls';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedShoppingButton } from './PdpSharedShoppingButton';

import { PdpSharedAddToCartButton_user$key } from './__generated__/PdpSharedAddToCartButton_user.graphql';
import { PdpSharedAddToCartButton_item$key } from './__generated__/PdpSharedAddToCartButton_item.graphql';

const userFragment = graphql`
    fragment PdpSharedAddToCartButton_user on User {
        ...PdpSharedShoppingButton_user
    }
`;
const itemFragment = graphql`
    fragment PdpSharedAddToCartButton_item on Item {
        ...PdpSharedShoppingButton_item
    }
`;

export const PdpSharedAddToCartButton: FC<{
    user: PdpSharedAddToCartButton_user$key | null;
    item: PdpSharedAddToCartButton_item$key;
    skuId?: string;
    quantitySelected?: string;
}> = ({ user: userRef, item: itemRef, skuId, quantitySelected }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);

    const intl = useIntl();

    const onClick = useCallback(() => {
        window.location.assign(handleLocaleUrl('/my/cart/', intl.locale));
    }, [intl.locale]);

    return (
        <PdpSharedShoppingButton
            user={user}
            item={item}
            quantitySelected={quantitySelected}
            skuId={skuId}
            type="secondary"
            onClick={onClick}
        >
            <FormattedMessage
                id="PdpSharedAddToCartButton.addToCart"
                defaultMessage="Add to cart"
            />
        </PdpSharedShoppingButton>
    );
};
